import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=0e4a1764&"
import script from "./OrderForm.ts?vue&type=script&lang=js&"
export * from "./OrderForm.ts?vue&type=script&lang=js&"
import style0 from "./OrderForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports